// BE Returns only one exchange source for now
export const rmaExchangeSources = {
    4: 'Rush Order'
};
